import type { SVGProps } from 'react';

const LightbulbIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M9 18h6" />
    <path d="M10 22h4" />
    <path d="M12 2a7 7 0 0 0-4 12.714V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.286A7 7 0 0 0 12 2z" />
  </svg>
);

const CheckmarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M8 12l2.5 3L16 9" />
  </svg>
);

export const INTERSTITIAL_ICON_REGISTRY: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  lightbulb: LightbulbIcon,
  checkmark: CheckmarkIcon,
};
